import React, { useMemo, useState } from "react";
import { emailScripts, objectionReplies } from "../../data/procrmData";

function OutreachLibrary() {
  const [selectedScript, setSelectedScript] = useState(emailScripts[0]);

  const [recipientEmail, setRecipientEmail] = useState("");
  const [contactName, setContactName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [yourName, setYourName] = useState("Leighché from ProCode ZA");

  const personalisedSubject = useMemo(() => {
    let subject = selectedScript.subject || "Digital Growth Opportunity";

    subject = subject
      .replaceAll("[INSERT BUSINESS NAME]", businessName || "[INSERT BUSINESS NAME]")
      .replaceAll("[BUSINESS NAME]", businessName || "[BUSINESS NAME]")
      .replaceAll("[INSERT NAME]", contactName || "[INSERT NAME]")
      .replaceAll("[YOUR NAME]", yourName || "[YOUR NAME]");

    return subject;
  }, [selectedScript, businessName, contactName, yourName]);

  const personalisedText = useMemo(() => {
    let text = selectedScript.text || "";

    text = text
      .replaceAll("[INSERT NAME / TEAM]", contactName || "[INSERT NAME / TEAM]")
      .replaceAll("[INSERT NAME]", contactName || "[INSERT NAME]")
      .replaceAll("[BUSINESS NAME]", businessName || "[BUSINESS NAME]")
      .replaceAll("[INSERT BUSINESS NAME]", businessName || "[INSERT BUSINESS NAME]")
      .replaceAll("[YOUR NAME]", yourName || "[YOUR NAME]");

    return text;
  }, [selectedScript, businessName, contactName, yourName]);

  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied successfully.");
    } catch {
      alert("Could not copy text.");
    }
  };

  const sendEmail = () => {
    if (!recipientEmail.trim()) {
      alert("Please enter the recipient email address first.");
      return;
    }

    const mailtoLink = `mailto:${encodeURIComponent(
      recipientEmail
    )}?subject=${encodeURIComponent(personalisedSubject)}&body=${encodeURIComponent(
      personalisedText
    )}`;

    window.location.href = mailtoLink;
  };

  return (
    <section className="crm-two-column">
      <div className="procrm-panel">
        <div className="panel-heading">
          <div>
            <span className="eyebrow">Outreach Library</span>
            <h2>Approved scripts</h2>
          </div>
        </div>

        <div className="blurb-list">
          {emailScripts.map((script) => (
            <button
              key={script.title}
              className={`blurb-card ${
                selectedScript.title === script.title ? "active" : ""
              }`}
              onClick={() => setSelectedScript(script)}
            >
              <span>{script.category}</span>
              <strong>{script.title}</strong>
            </button>
          ))}
        </div>
      </div>

      <div className="procrm-panel">
        <div className="panel-heading">
          <div>
            <span className="eyebrow">Ready-to-send Copy</span>
            <h2>{selectedScript.title}</h2>
          </div>
        </div>

        <div className="crm-form-grid">
          <div className="crm-field">
            <label>Recipient Email</label>
            <input
              type="email"
              value={recipientEmail}
              onChange={(e) => setRecipientEmail(e.target.value)}
              placeholder="example@business.co.za"
            />
          </div>

          <div className="crm-field">
            <label>Contact Name</label>
            <input
              type="text"
              value={contactName}
              onChange={(e) => setContactName(e.target.value)}
              placeholder="e.g. Sarah / Team"
            />
          </div>

          <div className="crm-field">
            <label>Business Name</label>
            <input
              type="text"
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
              placeholder="e.g. ABC Interiors"
            />
          </div>

          <div className="crm-field">
            <label>Your Name</label>
            <input
              type="text"
              value={yourName}
              onChange={(e) => setYourName(e.target.value)}
              placeholder="Leighché from ProCode ZA"
            />
          </div>
        </div>

        <div className="script-subject">
          <strong>Subject:</strong> {personalisedSubject}
        </div>

        <textarea className="script-box" value={personalisedText} readOnly />

        <div className="crm-action-row">
          <button
            className="procrm-btn-outline"
            onClick={() => copyText(personalisedText)}
          >
            Copy Script
          </button>

          <button className="procrm-btn" onClick={sendEmail}>
            Send Email
          </button>
        </div>
      </div>

      <div className="procrm-panel crm-wide-panel">
        <div className="panel-heading">
          <div>
            <span className="eyebrow">Objection Handling</span>
            <h2>Common replies</h2>
          </div>
        </div>

        <div className="crm-objection-grid">
          {objectionReplies.map((item) => (
            <div key={item.objection} className="playbook-card">
              <span>Objection</span>
              <h3>{item.objection}</h3>
              <p>{item.reply}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OutreachLibrary;